import React, { useEffect, useState, useRef } from "react"
import Input from "@/components/core/Input/Input"
import Button from "@/components/core/Button/Button"
import AccountsLayoutNonLoggedIn from "@/components/AccountsLayoutNonLoggedIn"
import styles from "@/components/Shared/OrderStatus/v1/index.module.scss"
import { fetchOrderDataByOrderId } from "@/utils/orders"
import OrderTile from "@/components/Shared/OrderStatus/v1/OrderTile"
import { getConfig } from "@/constants/config"
import { getShortenedUrl } from "@/utils/location"
import _get from "lodash/get"
import useWindowResize from "@/hooks/useWindowResize"

// import { log } from "@Services/logger.service"

const OrderStatus = ({ i18n, cartcontactDetails = [], ...props }) => {
  const [data, setData] = useState({
    orderNo: { value: "" },
  })
  const [orderDetails, setOrderDetails] = useState(null)
  const [loading, setLoading] = useState(false)
  const [initialConfig, setInitialConfig] = useState(null)
  const [width] = useWindowResize()
  const [isMobile, setIsMobile] = useState(width <= 1203)
  const [isValid, setIsValid] = useState(true)
  useEffect(() => {
    getConfig().then(config => {
      setInitialState(config)
    })
  }, [])
  const setInitialState = async config => {
    const accountSettingsPath = await getShortenedUrl(
      _get(config, "general.accountSettingsPath", "")
    )
    const myFavoritesPagePath = await getShortenedUrl(
      _get(config, "general.myFavoritesPagePath", "")
    )
    const orderHistoryPath = await getShortenedUrl(
      _get(config, "general.orderHistoryPath", "")
    )
    const myProductsPath = await getShortenedUrl(
      _get(config, "general.myProductsPath", "")
    )
    const myServicesPath = await getShortenedUrl(
      _get(config, "general.myServicesPath", "")
    )
    const contactUspath = await getShortenedUrl(
      _get(config, "apiEndpoints.contactUsPath", "")
    )
    const orderDetailsUrl = _get(config, "general.orderDetailsPath", "")
    const continueShopUrl = _get(config, "general.continueShopPath", "")
    const currencySign = _get(config, "internationalization.currencySign", "")
    setInitialConfig({
      accountSettingsPath,
      myFavoritesPagePath,
      orderHistoryPath,
      myProductsPath,
      myServicesPath,
      orderDetailsUrl,
      continueShopUrl,
      currencySign,
      contactUspath,
    })
  }
  const handleSubmit = async () => {
    let valid = true
    const { orderNo } = data
    if (!orderNo.value) {
      valid = false
    }
    if (valid) {
      setLoading(true)
      const res = await fetchOrderDataByOrderId(orderNo.value)
      const { order_detail = {} } = res
      setLoading(false)

      if (Object.keys(order_detail).length) {
        let shipments = order_detail.shipments
        const orderDate = new Date(order_detail.orderDate)
        const orderDetails = {
          orderNo: _get(order_detail, "orderNumber", ""),
          totalItems: shipments.reduce((a, b) => {
            return a + Math.trunc(b.itemCount)
          }, 0),
          orderStatus: _get(order_detail, "orderStatus", ""),
          orderDate: `${orderDate.toLocaleString("default", {
            month: "long",
          })} ${orderDate.getDate()}, ${orderDate.getFullYear()}`,
          orderTotal: Number(
            _get(order_detail, "order_summary.totalAmount", 0)
          ).toFixed(2),
        }
        setOrderDetails(orderDetails)
      } else {
        setOrderDetails({})
        setLoading(false)
      }
    }
  }
  useEffect(() => {
    setIsMobile(width <= 1024)
  }, [width])
  const checkIsValid = orderId => {
    if (orderId !== "") {
      const orderIdRegEx = /^[D][A-Z0-9-]+$/
      const isMatch = orderIdRegEx.test(orderId)
      if (isMatch) setIsValid(true)
      else setIsValid(false)
    } else {
      setIsValid(true)
    }
  }
  return (
    <>
      <AccountsLayoutNonLoggedIn title={i18n.title} i18n={i18n}>
        <div className={styles.orderStatusWrapper}>
          <div className="row no-gutters">
            {!isMobile ? (
              <div className="order-status__heading">{i18n.orders}</div>
            ) : null}
            <div className="order-status__form">
              <div className="order-status__form-content">
                <div className="order-status__help-text">
                  {"Check your order detail"}
                </div>
                <div className="order-status__help-description">
                  {"Enter your order ID below to check order detail. "}
                </div>
                <div className="order-status__form-div">
                  <Input
                    id="kf-order-status-number"
                    type="text"
                    name="orderNo"
                    value={data.orderNo.value}
                    placeholder={`${i18n.orderID}`}
                    label={`${i18n.orderID}`}
                    customClass="order-status__input"
                    onChange={e => {
                      setData({
                        orderNo: {
                          value: e.target.value,
                        },
                      })
                      checkIsValid(e.target.value)
                    }}
                  />
                  <Button
                    customClass="order-status__find-btn"
                    type="ghost"
                    flexible={true}
                    label={i18n.checkOrder}
                    onClick={handleSubmit}
                    role={"button"}
                    loading={loading}
                    disabled={!data.orderNo.value || loading || !isValid}
                  />
                </div>
              </div>
              {!isValid ? (
                <div className="order-status__error">
                  {"Invalid order ID. Please enter a valid order ID."}
                </div>
              ) : null}
            </div>

            {orderDetails && Object.keys(orderDetails).length > 0 && (
              <>
                <div className="order-status__header">
                  <div className="order-status__title">{"Your Order"}</div>
                </div>

                <OrderTile
                  data={orderDetails}
                  info={initialConfig}
                  i18n={i18n}
                />
              </>
            )}
            {orderDetails && Object.keys(orderDetails).length === 0 && (
              <div className="order-status__no-result">{i18n.noResult}</div>
            )}
          </div>
        </div>
      </AccountsLayoutNonLoggedIn>
    </>
  )
}

export default OrderStatus
